import siteUrl from '@/utils/url/site'
import param from '@/utils/url/param'

export default async (args = {}) => {
  let { whatsapp } = site, buttons = []
  if (whatsapp) {
    buttons.push({
      color: "success darken-1",
      icon: 'whatsapp',
      text: "Whatsapp",
      action: 'https://api.whatsapp.com/send' +
        param({
          phone: '55' + whatsapp.replace(/[^0-9]+/g, '')
        })
    })
  }
  return {
    msg: site.whatsapp
      ? `Nosso <strong>Whatsapp</strong> é ${whatsapp}`
      : `Nós não possuímos <strong>Whatsapp</strong>`,
    buttons
  }
}